var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"max-size"},[_c('TopNavbar'),_c('router-view',{staticClass:"container custom-container"}),_c('GeneralMenu'),_c('AllFiltersModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }